import React from 'react';

import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { CalendarIcon, PhoneHelpIcon, TelegramIcon } from '@icons';

import { useModals } from '@shared/contexts';

import PartyPopper from '@assets/images/party_popper.webp';
import Placeholder from '@assets/images/promotions/promo_placeholder.webp';

import { UserPromotionCardType } from '@types';

import { Button } from '@components/button';
import { Modal } from '@components/modal';

import { ModalName } from '../types';
import * as Styled from './promotion-winner-modal.styled';

interface ModalDataType {
	winner: UserPromotionCardType;
}

const PromotionWinnerModal = () => {
	const { isModalOpen, closeModal, getModalData } = useModals();
	const { t } = useTranslation('promotions');

	const modalData = getModalData<ModalDataType>(ModalName.PROMOTION_WINNER);

	return (
		<Modal hasCloseButton={false} isOpen={isModalOpen(ModalName.PROMOTION_WINNER)} closeModal={closeModal}>
			<Styled.Wrapper>
				<Styled.ImageWrapper>
					<Styled.Image src={modalData?.winner.image === null ? Placeholder : modalData?.winner.image} />
				</Styled.ImageWrapper>
				<Styled.UpperSection>
					<Styled.Congrats>
						<Styled.PartyPopperWrapper>
							<Styled.PartyPopper src={PartyPopper} />
						</Styled.PartyPopperWrapper>
						{t('WinCongrats')}
					</Styled.Congrats>
					<Styled.DatePrizeRow>
						<Styled.DatePrizeText>
							<Styled.CalendarIconWrapper>
								<CalendarIcon />
							</Styled.CalendarIconWrapper>
							{dayjs(modalData?.winner.end_date).format('DD.MM.YYYY')}
						</Styled.DatePrizeText>
						<Styled.DatePrizeText>
							<Styled.CalendarIconWrapper></Styled.CalendarIconWrapper>
							{modalData?.winner.prize.name}
						</Styled.DatePrizeText>
					</Styled.DatePrizeRow>
				</Styled.UpperSection>
				<Styled.LowerSection>
					<Styled.Description>
						{t('YouWinIn')} “{modalData?.winner.name}”. {t('ContactSupport')}
					</Styled.Description>
					<Styled.SupportLinks>
						<Styled.HelpButton to={'https://t.me/PMKzSupport_bot'} target='_blank'>
							<Styled.HelpIconWrapper>
								<PhoneHelpIcon />
							</Styled.HelpIconWrapper>
							9933
						</Styled.HelpButton>
						<Styled.HelpButton $isTelegram to={'https://t.me/PMKzSupport_bot'} target='_blank'>
							<Styled.HelpIconWrapper>
								<TelegramIcon />
							</Styled.HelpIconWrapper>
							@PMKzSupport_bot
						</Styled.HelpButton>
					</Styled.SupportLinks>
				</Styled.LowerSection>
				<Styled.ButtonRow>
					<Button color='dark' onClick={closeModal}>
						{t('main:close')}
					</Button>
				</Styled.ButtonRow>
			</Styled.Wrapper>
		</Modal>
	);
};

export default PromotionWinnerModal;
